import { registerAction } from '../../Action'

const OPEN_FILTERS_TRAY = 'OPEN_FILTERS_TRAY'

const reducer = (state = {}) => ({
  ...state,
  filters: {
    ...state.filters,
    ...{
      isTrayOpen: true,
    },
  },
})

const openFiltersTray = registerAction(OPEN_FILTERS_TRAY, { reducer })

export default openFiltersTray
